import { render } from "./ModalProductRemove.vue?vue&type=template&id=65fff9a9&scoped=true"
import script from "./ModalProductRemove.vue?vue&type=script&lang=js"
export * from "./ModalProductRemove.vue?vue&type=script&lang=js"

import "./ModalProductRemove.vue?vue&type=style&index=0&id=65fff9a9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fff9a9"]])

export default __exports__